import React from 'react'

const ClientDetailPage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-2xl font-bold text-gray-900">Client Details</h1>
      <div className="mt-8 card">
        <div className="card-body">
          <p className="text-gray-500 text-center py-8">Client details coming soon...</p>
        </div>
      </div>
    </div>
  )
}

export default ClientDetailPage
